// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2055":"1d63a150e604a049","7444":"060787d11cea7316","8269":"3b4fcaf1e79b4059"}[chunkId] + ".css";
};